import { useEffect, useRef } from "react";
import api from "./api";

// Heartbeat from an open, actively-used tab. Only genuine in-app time counts:
// a background tab or an idle screen stops pinging on its own and the minute
// simply never gets recorded.
const IDLE_MS = 5 * 60 * 1000;
const EVENTS = ["mousemove", "mousedown", "keydown", "scroll", "touchstart", "click"];

export default function useActivityPing(enabled) {
  const lastTouch = useRef(Date.now());
  useEffect(() => {
    if (!enabled) return undefined;
    const touch = () => { lastTouch.current = Date.now(); };
    EVENTS.forEach((e) => window.addEventListener(e, touch, { passive: true }));
    const ping = () => {
      if (document.visibilityState !== "visible") return;
      if (Date.now() - lastTouch.current > IDLE_MS) return;
      api.post("/activity/ping").catch(() => {});
    };
    ping();
    const id = setInterval(ping, 60000);
    return () => {
      EVENTS.forEach((e) => window.removeEventListener(e, touch));
      clearInterval(id);
    };
  }, [enabled]);
}
